import ChatWidget from "@/components/ChatWidget";

export default function ChatPage() {
  return (
    <div className="space-y-6" data-testid="patient-chat-page">
      <div>
        <div className="overline text-accent mb-3">Comunicação</div>
        <h1 className="font-heading text-3xl md:text-4xl font-bold tracking-tight">Chat com a equipe clínica</h1>
        <p className="text-muted-foreground mt-2">Tire dúvidas sobre seu protocolo, efeitos e ajustes diretamente com o farmacêutico.</p>
      </div>
      <div className="max-w-3xl">
        <ChatWidget />
      </div>
    </div>
  );
}
